import { useState, useRef, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useBreakpoint } from "../hooks/useBreakpoint";

/* ── Fonts ── */
if (typeof document !== "undefined" && !document.getElementById("__profeed_fonts")) {
  const l = document.createElement("link");
  l.id = "__profeed_fonts";
  l.rel = "stylesheet";
  l.href = "https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&display=swap";
  document.head.appendChild(l);
}

const T = {
  green: "#1e9254", greenDark: "#155c36", greenTint: "#eef8f3", greenBorder: "#a7d9bc",
  bg: "#F7F8FA", white: "#FFFFFF", border: "#E5E7EB",
  text: "#0f1117", textMid: "#2d3549", sub: "#4a5268", faint: "#8a93a8",
  serif: "'Instrument Serif', Georgia, serif",
  sans: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
  tx: "all 0.20s cubic-bezier(.4,0,.2,1)",
};

export const FEED_ITEMS = [
  {
    id: 1, tier: "Business Pro", category: "Plumbing",
    providerName: "James Otieno", initials: "JO",
    avatarBg: "#DCFCE7", avatarBorder: "#A7D9BC", avatarColor: "#155c36",
    location: "Westlands, Nairobi", rating: 4.9, jobs: 186, views: "12.4k", likes: "834",
    description: "Full bathroom re-pipe completed in 4 hours — from diagnosis to final pressure test, uncut.",
    thumbnail: "https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=480&h=854&fit=crop&crop=center",
    comments: [
      { id: 1, user: "Brian K.", initials: "BK", avatarBg: "#DBEAFE", avatarColor: "#1D4ED8", text: "This is exactly the quality I was looking for. Booked!", time: "2h ago" },
      { id: 2, user: "Mercy N.", initials: "MN", avatarBg: "#FCE7F3", avatarColor: "#9D174D", text: "James did my pipes last month. Absolutely professional 🙌", time: "5h ago" },
      { id: 3, user: "Tom O.", initials: "TO", avatarBg: "#FEF9C3", avatarColor: "#92400E", text: "What's the price for a full re-pipe like this?", time: "1d ago" },
    ],
  },
  {
    id: 2, tier: "Verified Pro", category: "Cleaning & Laundry",
    providerName: "Mary Wanjiku", initials: "MW",
    avatarBg: "#FEF9C3", avatarBorder: "#FDE68A", avatarColor: "#92400E",
    location: "Kilimani, Nairobi", rating: 5.0, jobs: 312, views: "28.1k", likes: "2.1k",
    description: "Deep kitchen clean from ceiling to floor — stubborn grease and tile grouting tackled in under 3 hours.",
    thumbnail: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=480&h=854&fit=crop&crop=center",
    comments: [
      { id: 1, user: "Aisha M.", initials: "AM", avatarBg: "#EDE9FE", avatarColor: "#6D28D9", text: "My kitchen looks brand new after Mary came. Highly recommend!", time: "1h ago" },
      { id: 2, user: "Kevin L.", initials: "KL", avatarBg: "#DCFCE7", avatarColor: "#166534", text: "5 stars every single time 👏", time: "3h ago" },
    ],
  },
  {
    id: 3, tier: "Business Pro", category: "Electrical",
    providerName: "David Kamau", initials: "DK",
    avatarBg: "#DBEAFE", avatarBorder: "#BFDBFE", avatarColor: "#1D4ED8",
    location: "South B, Nairobi", rating: 4.8, jobs: 224, views: "19.7k", likes: "1.4k",
    description: "Full consumer unit upgrade — replacing an old fuse board with a modern 18-way MCB board, step-by-step.",
    thumbnail: "https://images.unsplash.com/photo-1544724569-5f546fd6f2b5?w=480&h=854&fit=crop&crop=center",
    comments: [
      { id: 1, user: "Grace A.", initials: "GA", avatarBg: "#DCFCE7", avatarColor: "#166534", text: "David upgraded my board last week. Clean work and on time!", time: "4h ago" },
    ],
  },
  {
    id: 4, tier: "Business Pro", category: "Hair & Beauty",
    providerName: "Faith Muthoni", initials: "FM",
    avatarBg: "#FCE7F3", avatarBorder: "#F9A8D4", avatarColor: "#9D174D",
    location: "Lavington, Nairobi", rating: 4.9, jobs: 401, views: "41.2k", likes: "3.8k",
    description: "Box braids from scratch — natural hair prep, extensions applied and sealed in one sitting.",
    thumbnail: "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=480&h=854&fit=crop&crop=center",
    comments: [
      { id: 1, user: "Priya K.", initials: "PK", avatarBg: "#DBEAFE", avatarColor: "#1D4ED8", text: "Faith is an absolute artist. My braids lasted 8 weeks!", time: "30m ago" },
      { id: 2, user: "Sandra W.", initials: "SW", avatarBg: "#FEF9C3", avatarColor: "#92400E", text: "How long did this take?", time: "2h ago" },
      { id: 3, user: "Faith Muthoni", initials: "FM", avatarBg: "#FCE7F3", avatarColor: "#9D174D", text: "About 5 hours for a full set like this 😊", time: "2h ago" },
    ],
  },
  {
    id: 5, tier: "Verified Pro", category: "Photography",
    providerName: "Sam Njoroge", initials: "SN",
    avatarBg: "#EDE9FE", avatarBorder: "#C4B5FD", avatarColor: "#6D28D9",
    location: "Upperhill, Nairobi", rating: 5.0, jobs: 158, views: "33.9k", likes: "2.9k",
    description: "Behind the scenes of a full fashion product shoot — lighting, angles, and editing walk-through.",
    thumbnail: "https://images.unsplash.com/photo-1452587925148-ce544e77e70d?w=480&h=854&fit=crop&crop=center",
    comments: [
      { id: 1, user: "Kevin O.", initials: "KO", avatarBg: "#DBEAFE", avatarColor: "#1D4ED8", text: "Booked Sam for my product launch. Best decision I made.", time: "6h ago" },
    ],
  },
  {
    id: 6, tier: "Verified Pro", category: "Carpentry",
    providerName: "Peter Luo", initials: "PL",
    avatarBg: "#FEF9C3", avatarBorder: "#FDE68A", avatarColor: "#92400E",
    location: "Karen, Nairobi", rating: 4.9, jobs: 203, views: "17.5k", likes: "1.2k",
    description: "Custom wardrobe build from raw timber to finished installation — three-day project, 90-second watch.",
    thumbnail: "https://images.unsplash.com/photo-1504148455328-c376907d081c?w=480&h=854&fit=crop&crop=center",
    comments: [],
  },
  {
    id: 7, tier: "Business Pro", category: "Tutoring",
    providerName: "Grace Achieng", initials: "GA",
    avatarBg: "#DCFCE7", avatarBorder: "#A7D9BC", avatarColor: "#166534",
    location: "Hurlingham, Nairobi", rating: 5.0, jobs: 97, views: "9.8k", likes: "712",
    description: "KCSE Mathematics revision — Form 4 quadratics solved live, with common exam mistakes called out clearly.",
    thumbnail: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=480&h=854&fit=crop&crop=center",
    comments: [
      { id: 1, user: "Parent J.", initials: "PJ", avatarBg: "#FEF9C3", avatarColor: "#92400E", text: "My daughter went from C to A after sessions with Grace 🙏", time: "1d ago" },
    ],
  },
];

/* ── Tier Badge ── */
function TierBadge({ tier }) {
  const isBP = tier === "Business Pro";
  return (
    <div style={{
      display: "inline-flex", alignItems: "center", gap: 5,
      background: isBP ? "rgba(255,251,235,0.95)" : "rgba(238,248,243,0.95)",
      border: `1px solid ${isBP ? "#FDE68A" : "#a7d9bc"}`,
      color: isBP ? "#92400E" : "#155c36",
      fontSize: 10, fontWeight: 700, padding: "3px 9px",
      borderRadius: 6, letterSpacing: ".03em", fontFamily: T.sans,
      backdropFilter: "blur(4px)",
    }}>
      {isBP ? (
        <svg width="11" height="11" viewBox="0 0 24 24" fill="#D97706" stroke="none">
          <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z"/>
        </svg>
      ) : (
        <svg width="11" height="11" viewBox="0 0 24 24" fill="#1e9254" stroke="none">
          <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/>
          <path d="M9 12l2 2 4-4" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )}
      {tier}
    </div>
  );
}

const EyeIcon = () => <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>;
const HeartIcon = () => <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>;
const PinIcon = () => <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke={T.faint} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></svg>;
const StarIcon = () => <svg width="11" height="11" viewBox="0 0 24 24" fill="#FBBF24" stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>;
const PlayIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff" stroke="none"><polygon points="5,3 19,12 5,21"/></svg>;

function ProFeedCard({ item, onViewProfile, onBookNow }) {
  const [hovered, setHovered] = useState(false);
  const [imgError, setImgError] = useState(false);
  const isBP = item.tier === "Business Pro";

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        width: 252, borderRadius: 20, background: T.white, flexShrink: 0,
        border: `1.5px solid ${hovered ? T.greenBorder : T.border}`,
        overflow: "hidden", cursor: "pointer",
        boxShadow: hovered ? "0 16px 44px rgba(0,0,0,.11)" : "0 2px 12px rgba(0,0,0,.04)",
        transform: hovered ? "translateY(-4px)" : "translateY(0)",
        transition: T.tx, display: "flex", flexDirection: "column",
      }}>

      {/* Thumbnail */}
      <div style={{
        position: "relative", aspectRatio: "9/16", maxHeight: 336,
        overflow: "hidden", background: imgError ? "#2d3549" : "#1a1a2e", flexShrink: 0,
      }}>
        {!imgError && (
          <img src={item.thumbnail} alt={`${item.providerName}`}
            onError={() => setImgError(true)}
            style={{
              width: "100%", height: "100%", objectFit: "cover", display: "block",
              transform: hovered ? "scale(1.04)" : "scale(1)",
              transition: "transform 0.5s cubic-bezier(.4,0,.2,1)",
            }}/>
        )}
        <div style={{
          position: "absolute", inset: 0,
          background: "linear-gradient(to top,rgba(0,0,0,.80) 0%,rgba(0,0,0,.18) 45%,transparent 70%)",
          pointerEvents: "none",
        }}/>
        <div style={{
          position: "absolute", top: "50%", left: "50%",
          transform: "translate(-50%,-50%)", width: 46, height: 46, borderRadius: "50%",
          background: "rgba(255,255,255,.18)", border: "1.5px solid rgba(255,255,255,.38)",
          display: "flex", alignItems: "center", justifyContent: "center",
          opacity: hovered ? 1 : 0, transition: "opacity .2s",
        }}><PlayIcon/></div>

        {/* Tier — top left */}
        <div style={{ position: "absolute", top: 10, left: 10 }}>
          <TierBadge tier={item.tier}/>
        </div>

        {/* Category — top right, tight to edge */}
        <div style={{
          position: "absolute", top: 10, right: 8,
          background: "rgba(0,0,0,.55)", backdropFilter: "blur(4px)",
          color: "rgba(255,255,255,.92)", fontSize: 10, fontWeight: 600,
          padding: "3px 8px", borderRadius: 5, fontFamily: T.sans,
        }}>
          {item.category}
        </div>

        {/* Stats */}
        <div style={{ position: "absolute", bottom: 44, left: 10, display: "flex", gap: 7 }}>
          {[{ icon: <EyeIcon/>, v: item.views }, { icon: <HeartIcon/>, v: item.likes }].map((s, i) => (
            <div key={i} style={{
              display: "inline-flex", alignItems: "center", gap: 4,
              background: "rgba(0,0,0,.42)", backdropFilter: "blur(4px)",
              color: "#fff", fontSize: 11, fontWeight: 500,
              padding: "3px 8px", borderRadius: 999, fontFamily: T.sans,
            }}>{s.icon}{s.v}</div>
          ))}
        </div>

        <div style={{ position: "absolute", bottom: 12, left: 10, display: "flex", alignItems: "center", gap: 4 }}>
          <StarIcon/>
          <span style={{ color: "#fff", fontSize: 11.5, fontWeight: 600, fontFamily: T.sans }}>
            {item.rating.toFixed(1)} · {item.jobs} jobs
          </span>
        </div>
      </div>

      {/* Body */}
      <div style={{ padding: "13px 13px 13px", display: "flex", flexDirection: "column", flex: 1 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
          <div style={{
            width: 32, height: 32, borderRadius: "50%", flexShrink: 0,
            background: item.avatarBg, border: `2px solid ${item.avatarBorder}`,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 11, fontWeight: 700, color: item.avatarColor, fontFamily: T.sans,
          }}>{item.initials}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{
              fontSize: 13, fontWeight: 600, color: T.text,
              whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
              lineHeight: 1.3, fontFamily: T.sans,
            }}>{item.providerName}</div>
            <div style={{ fontSize: 11, color: T.faint, display: "flex", alignItems: "center", gap: 3, marginTop: 1, fontFamily: T.sans }}>
              <PinIcon/>{item.location}
            </div>
          </div>
          <div style={{
            fontSize: 10.5, fontWeight: 600, color: T.green,
            background: T.greenTint, border: `1px solid ${T.greenBorder}`,
            padding: "2px 7px", borderRadius: 5, whiteSpace: "nowrap", flexShrink: 0, fontFamily: T.sans,
          }}>{item.jobs} jobs</div>
        </div>

        {/* Description — locked 2-line height so buttons always align */}
        <p style={{
          fontSize: 12, color: T.sub, lineHeight: 1.55, margin: "0 0 12px",
          display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical",
          overflow: "hidden", fontFamily: T.sans, minHeight: "calc(1.55em * 2)",
        }}>{item.description}</p>

        {/* CTAs — pinned to bottom via marginTop auto */}
        <div style={{ display: "flex", gap: 8, marginTop: "auto" }}>
          <button
            onClick={() => onViewProfile(item)}
            style={{
              flex: 1, height: 36, borderRadius: 10,
              border: `1.5px solid ${T.border}`, background: "transparent",
              fontSize: 12, fontWeight: 600, color: T.textMid,
              cursor: "pointer", fontFamily: T.sans, transition: T.tx,
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = T.greenBorder; e.currentTarget.style.background = T.greenTint; e.currentTarget.style.color = T.green; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = T.border; e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = T.textMid; }}
          >View Profile</button>
          <button
            onClick={() => onBookNow(item)}
            style={{
              flex: 1.4, height: 36, borderRadius: 10, border: "none",
              background: isBP ? "#D97706" : T.green,
              fontSize: 12, fontWeight: 600, color: "#fff",
              cursor: "pointer", fontFamily: T.sans, transition: T.tx,
            }}
            onMouseEnter={e => { e.currentTarget.style.background = isBP ? "#B45309" : T.greenDark; }}
            onMouseLeave={e => { e.currentTarget.style.background = isBP ? "#D97706" : T.green; }}
          >Book Now</button>
        </div>
      </div>
    </div>
  );
}

function ScrollArrow({ dir, enabled, onClick }) {
  const [h, setH] = useState(false);
  return (
    <button onClick={onClick} disabled={!enabled}
      onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)}
      style={{
        width: 36, height: 36, borderRadius: "50%",
        border: `1.5px solid ${enabled && h ? T.greenBorder : T.border}`,
        background: enabled && h ? T.greenTint : T.white,
        display: "flex", alignItems: "center", justifyContent: "center",
        cursor: enabled ? "pointer" : "default",
        opacity: enabled ? 1 : 0.3, transition: T.tx,
      }}>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
        stroke={enabled && h ? T.green : T.sub} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        {dir === 1 ? <><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></> : <><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></>}
      </svg>
    </button>
  );
}

export default function ProFeed() {
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const { isMobile, isTablet } = useBreakpoint();
  const padX = isMobile ? 16 : isTablet ? 20 : 32;
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const filteredItems = FEED_ITEMS;

  const updateScroll = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 8);
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 8);
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    el.addEventListener("scroll", updateScroll, { passive: true });
    updateScroll();
    return () => el.removeEventListener("scroll", updateScroll);
  }, [updateScroll, filteredItems]);

  const scroll = (dir) => scrollRef.current?.scrollBy({ left: dir * 560, behavior: "smooth" });

  return (
    <section style={{ background: T.bg, padding: "60px 0 8px", width: "100%", overflow: "hidden" }}>
      <style>{`.pf-track::-webkit-scrollbar{display:none}.pf-track{-ms-overflow-style:none;scrollbar-width:none}`}</style>

      {/* Header — full width, padX, no maxWidth cap (same pattern as
          PopularServices), so it can never drift from the track below */}
      <div style={{ width: "100%", padding: `0 ${padX}px` }}>
        <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", gap: 24, marginBottom: 28, flexWrap: "wrap" }}>
          <div>
            <h2 style={{ fontFamily: T.serif, fontSize: "clamp(28px,4vw,38px)", fontWeight: 400, color: T.text, lineHeight: 1.08, letterSpacing: "-0.03em", margin: "0 0 7px" }}>
              Trending on <em style={{ fontStyle: "italic", color: T.green }}>ProFeed</em>
            </h2>
            <p style={{ fontSize: 15, color: T.sub, lineHeight: 1.65, margin: 0, fontFamily: T.sans }}>
              Watch real work from trusted local professionals across Kenya.
            </p>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }}>
            <ScrollArrow dir={-1} enabled={canScrollLeft} onClick={() => scroll(-1)}/>
            <ScrollArrow dir={1} enabled={canScrollRight} onClick={() => scroll(1)}/>
            <button
              onClick={() => navigate("/profeed")}
              style={{
                display: "inline-flex", alignItems: "center", gap: 6,
                fontSize: 13, fontWeight: 600, color: T.green,
                border: `1.5px solid ${T.greenBorder}`, padding: "9px 18px",
                borderRadius: 999, cursor: "pointer", fontFamily: T.sans,
                transition: T.tx, background: "transparent",
              }}
              onMouseEnter={e => { e.currentTarget.style.background = T.greenTint; e.currentTarget.style.borderColor = T.green; }}
              onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.borderColor = T.greenBorder; }}
            >
              See all videos
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Track — full width, padX on both sides, bleeds past 1200 on
          wide screens. No edge fade gradients. */}
      <div
        ref={scrollRef}
        className="pf-track"
        style={{ overflowX: "auto", paddingBottom: 16, paddingLeft: padX, paddingRight: padX, width: "100%" }}
      >
        <div style={{ display: "flex", gap: 16, width: "max-content", alignItems: "stretch" }}>
          {filteredItems.map(item => (
            <ProFeedCard key={item.id} item={item}
              onViewProfile={i => navigate(`/pro/${i.id}`)}
              onBookNow={i => navigate(`/pro/${i.id}?book=1`)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}